import objTealium from 'src/utils/Tealium/Tealium';
import { Link, View } from '../types/tealium-service';

const attempt = (func: () => void) => {
  try {
    func();
  } catch (error) {
    console.error(error);
    // intentional swallowing of non functional error
  }
};

export const sendLinkToTealium = (obj: Link) => {
  const linkObj = {
    ...obj,
    event_name: obj.event_name.join(', '),
  };

  attempt(() => {
    objTealium.link(linkObj);
  });
};

export const sendViewToTealium = (obj: View) => {
  const viewObj = {
    ...obj,
    event_name: obj.event_name.join(', '),
  };

  attempt(() => {
    objTealium.view(viewObj);
  });
};
